exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul {\n  margin: 0;\n  padding-left: 20px;\n}\n.anchor:hover {\n  cursor: pointer;\n}\n.content ul.image-bullet {\n  padding-left: 0;\n}\n.content .image-bullet li {\n  list-style: none;\n  background-size: 14px 14px;\n  background-repeat: no-repeat;\n  background-position: 2px 2px;\n  padding-left: 20px;\n  margin-bottom: 3px;\n}\n", ""]);

